import { schema } from 'normalizr';
import { SCHEMA_TYPE_VENDOR_ENDPOINT_PARAMS } from '../constants/schemaTypes';

const vendorEndpointParamSchema = new schema.Entity(
  SCHEMA_TYPE_VENDOR_ENDPOINT_PARAMS,
  {},
  {
    processStrategy: (value, parent, key) => {
      const { vendor_endpoint } = value;

      return {
        ...value,

        // manually mapping vendor_enpoint object to its ID because using
        // vendorEndpointSchema here causes compilation error due to circular
        // references
        vendor_endpoint: vendor_endpoint?.id,
      };
    },
  },
);

export default vendorEndpointParamSchema;
